import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RitualConfig } from '../../helpers/ritual';
import { CommonIcon } from '../common/CommonIcon';

interface RitualHeaderBannerProps {
    config: RitualConfig;
    completedCount: number;
    totalCount: number;
}

export const RitualHeaderBanner: FC<RitualHeaderBannerProps> = ({ config, completedCount, totalCount }) => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                backgroundColor: config.cardBg,
                borderRadius: '16px',
                padding: '20px',
                margin: '0 16px 16px',
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" gap={1.5}>
                    <CommonIcon
                        icon={config.icon}
                        type="outlined"
                        size={28}
                        color="white"
                    />
                    <Stack direction="column" gap={0.25}>
                        <Text style={{ fontSize: '20px', fontWeight: 600, color: 'white' }}>
                            {config.title}
                        </Text>
                        <Text style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)' }}>
                            {config.description}
                        </Text>
                    </Stack>
                </Stack>
                <Stack alignItems="flex-end">
                    <Text style={{ fontSize: '28px', fontWeight: 700, color: 'white' }}>
                        {completedCount}/{totalCount}
                    </Text>
                    <Text style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.7)' }}>
                        {t('ritual.completed')}
                    </Text>
                </Stack>
            </Stack>
        </Box>
    );
};
